export const USER_FRIEND_LIST_URL: string = '/v2/profiles/me/friends';
export const USER_FRIEND_PROFILE_URL: string = '/v2/profiles';
export const USER_PRODUCTS_URL: string = '/v1/users/global/webservices/productactivations/api/products';
export const USER_PROFILE_STAT_TEMPLATE: string = '/v1/profiles/{userId}/stats';
export const USER_DETAIL_INFO_URL: string = '/v3/users/me';
export const IP_LOCATION_URL = '/v2/profiles/me/iplocation';
export const GET_PRODUCT_DETAILS_URL: string = '/v1/mdm/products';
export const GET_SECONDARY_STORE_URL: string = '/v1/spaces/{spaceId}/items/{itemId}';

export enum USER_FRIEND_STATUS {
    FRIEND = 'Friends',
    PENDING_SENT_INVITE = 'PendingSentInvite',
}

export enum IUPCProductType {
    GAME = 0,
    ADDON = 1,
    PACKAGE = 5,
    CONSUMABLE = 8,
    CONSUMABLE_PACK = 10,
    BUNDLE = 11
}

export enum IUPCProductOwnership  {
    OWNED = 0,
    PRE_ORDERED = 1,
    REVOKED = 3,
    SUSPENDED = 4,
    LOCKED = 5
}
